import { FontWeights } from '@uifabric/styling';
import {
    RecipientWellLabelWithContactPickerStyleProps,
    RecipientWellLabelWithContactPickerStyles,
} from './RecipientWellLabelWithContactPicker.types';

export const getStyles = (
    props: RecipientWellLabelWithContactPickerStyleProps
): RecipientWellLabelWithContactPickerStyles => {
    const { theme, isClickable } = props;
    const { palette } = theme;
    const recipientSize = 32;

    return {
        label: [
            'RecipientWellLabelWithContactPicker-label',
            {
                display: 'inline-block',
                position: 'relative',
                height: recipientSize,
                lineHeight: recipientSize,
                margin: '11px 10px 0 0',
                minWidth: '52px',
                padding: '0 4px',
                textAlign: 'center',
                fontWeight: FontWeights.semibold,
                color: palette.themeDark,
                backgroundColor: palette.themeLighterAlt,
                borderRadius: '2px',
            },
            isClickable && {
                selectors: {
                    ':hover': {
                        backgroundColor: palette.themeLighter,
                    },
                    ':active': {
                        backgroundColor: palette.themeLight,
                    },
                },
                cursor: 'pointer',
            },
        ],
    };
};
